import React, { Component } from "react"
import { Modal } from "react-bootstrap"
import {
  EmailShareButton,
  EmailIcon,
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TwitterShareButton,
  TwitterIcon,
} from "react-share"

export default class Vmodal extends Component {
  constructor(props, context) {
    super(props, context)

    this.handleShow = this.handleShow.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.state = {
      show: false,
    }
  }

  handleClose() {
    this.setState({ show: false })
  }

  handleShow() {
    this.setState({ show: true })
  }

  render() {
    return (
      <>
        <button
          onClick={this.handleShow}
          className={this.props.buttonClassName}
        >
          Share <i className="fa fa-share-alt"></i>
        </button>

        <Modal
          size={this.props.size}
          show={this.state.show}
          onHide={this.handleClose}
          dialogClassName={this.props.mclass}
          centered
        >
          <button
            onClick={this.handleClose}
            aria-label="close"
            className="close"
          />
          <Modal.Body className={this.props.mbodyclass}>
            <span
              className="small text-uppercase d-block mb-2 mb-md-1 text-white"
              style={{ letterSpacing: "2px" }}
            >
              Share Us on:
            </span>
            <ul className="list-inline m-0">
              <li className="list-inline-item">
                <EmailShareButton
                  url={this.props.linkToShare}
                  target="_blank"
                  rel="noreferrer"
                >
                  <EmailIcon size={50} borderRadius={100} />
                </EmailShareButton>
              </li>
              <li className="list-inline-item">
                <FacebookShareButton url={this.props.linkToShare}>
                  <FacebookIcon size={50} borderRadius={100} />
                </FacebookShareButton>
              </li>
              <li className="list-inline-item">
                <TwitterShareButton url={this.props.linkToShare}>
                  <TwitterIcon size={50} borderRadius={100} />
                </TwitterShareButton>
              </li>
              <li className="list-inline-item">
                <LinkedinShareButton
                  url={this.props.linkToShare}
                  target="_blank"
                  rel="noreferrer"
                >
                  <LinkedinIcon size={50} borderRadius={100} />
                </LinkedinShareButton>
              </li>
            </ul>
          </Modal.Body>
        </Modal>
      </>
    )
  }
}
